export function downloadCSV(data: any[], filename: string): void {
    if (!data || data.length === 0) {
        console.warn("No data to download");
        return;
    }

    // Extract headers from first object
    const headers = Object.keys(data[0]);

    // Convert to CSV rows
    const csvRows = [
        headers.join(","),
        ...data.map((row) =>
            headers
                .map((h) => {
                    const value = row[h];
                    if (value === null || value === undefined) return "";
                    if (value instanceof Date) return value.toISOString();
                    // Handle nested objects/arrays by converting to JSON string
                    if (typeof value === "object") {
                        return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
                    }
                    if (
                        typeof value === "string" &&
                        (value.includes(",") || value.includes('"'))
                    ) {
                        return `"${value.replace(/"/g, '""')}"`;
                    }
                    return String(value);
                })
                .join(","),
        ),
    ];

    // Create blob and download
    const blob = new Blob([csvRows.join("\n")], {
        type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}
